import { useState } from 'react';
import {
  useGetPermissionsByUser,
  useGetUserPermissions,
} from '../data/hooks/permissions';
import { PermissionAlias } from '../utils/enums';

export type PermissionsState = PermissionAlias[];

export const usePermissions = () => {
  const { fetch: getTeamPermissionsFetcher } = useGetPermissionsByUser();
  const { fetch: getUserPermissionsFetcher } = useGetUserPermissions();

  const [permissions, setPermissions] = useState<PermissionAlias[]>([]);
  const [hasIndividualPermissions, setHasIndividualPermissions] =
    useState(false);

  const getPermissions = async () => {
    let teamPerms: PermissionAlias[] = [];
    let userPerms: PermissionAlias[] = [];

    await getTeamPermissionsFetcher({
      onSuccess: (list) => {
        teamPerms = list ?? [];
      },
    });

    await getUserPermissionsFetcher({
      onSuccess: (list) => {
        userPerms = list ?? [];
      },
    });

    setHasIndividualPermissions(userPerms.length > 0);
    const merged = Array.from(new Set([...teamPerms, ...userPerms]));
    setPermissions(merged);
  };

  const set = (permissions: PermissionsState) => {
    setPermissions(permissions);
  };

  return {
    set,
    getPermissions,
    permissions,
    hasIndividualPermissions,
  };
};
